/* @flow */
/* Do not edit - Generated by iconify. See README.md for more details. */
/* eslint-disable max-len */
import type { ElementConfig as ReactElementConfig } from "react"

import BaseIcon from "./BaseIcon";

export default class SvgIconCopy extends BaseIcon {
    static defaultProps: ReactElementConfig<typeof BaseIcon> = {
        iconClass: "CopyIcon",
    }

    svgContent: string = `
        <svg class='${this.classNames}' width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.74984 4.99998C1.74984 3.57498 2.90817 2.41665 4.33317 2.41665H7.6665V0.833313H4.33317C2.03317 0.833313 0.166504 2.69998 0.166504 4.99998C0.166504 7.29998 2.03317 9.16665 4.33317 9.16665H7.6665V7.58331H4.33317C2.90817 7.58331 1.74984 6.42498 1.74984 4.99998ZM5.1665 5.83331H11.8332V4.16665H5.1665V5.83331ZM12.6665 0.833313H9.33317V2.41665H12.6665C14.0915 2.41665 15.2498 3.57498 15.2498 4.99998C15.2498 6.42498 14.0915 7.58331 12.6665 7.58331H9.33317V9.16665H12.6665C14.9665 9.16665 16.8332 7.29998 16.8332 4.99998C16.8332 2.69998 14.9665 0.833313 12.6665 0.833313Z" fill="white"/></svg>
    `;
}
